export default __webpack_public_path__ + "2f830ce7ff7286fed6619b8671f97e0a.png";